import { useExportPayablesReport } from '../../hooks/useExportPayablesReport'
import { MenuItem } from '@/components/common/MenuItem/MenuItem'
import useToastStore from '@/stores/useToastStore/useToastStore'
import { useTranslation } from 'react-i18next'

export type ExportPayablesReportProps = {
    reportId: string
    onClick?: () => void
}

export const ExportPayablesReport: React.FC<ExportPayablesReportProps> = ({
    reportId,
    onClick,
}) => {
    const addAlert = useToastStore((state) => state.addAlert)
    const { t } = useTranslation('translations')
    const { exportPayablesReport } = useExportPayablesReport(reportId)

    return (
        <MenuItem
            path="/"
            variant="ghost"
            label={t('common.export_report_dropdown.options.xls')}
            render={({ renderContents }) => (
                <button
                    className="group w-full outline-none"
                    onClick={() => {
                        addAlert({
                            variant: 'success',
                            title: t(
                                'reporting.export_report.success_toast.title'
                            ),
                            description: t(
                                'reporting.export_report.success_toast.description'
                            ),
                        })
                        onClick?.()
                        exportPayablesReport()
                    }}
                    data-testid="export-payables-excel-button"
                >
                    {renderContents()}
                </button>
            )}
        />
    )
}
